import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {SearchUrlParameters} from "../model/search-url-parameters";
import {SearchParams} from "../../api/models/search-params";
import {SearchPageEvent} from "../model/search-page-event";
import {SearchEventTypeEnum} from "../model/search-event-type-enum";


@Injectable({
  providedIn: 'root'
})
export class SearchEventPublisher {
  private subject = new Subject<SearchPageEvent>();


  publishEvent(eventType: SearchEventTypeEnum, params: SearchUrlParameters | SearchParams) {
    const newParams: SearchUrlParameters = {...params};
    this.subject.next({eventType: eventType, searchParams: newParams});
  }

  getSearchTrigger(): Observable<SearchPageEvent> {
    return this.subject.asObservable();
  }


}
